/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.4",
    versionName: "0.2.0-nightly.2025.11.4",
    versionChannel: "nightly",
    buildDate: "2025-11-04T00:09:01.599Z",
    commitHash: "48b1761c31fc39e78d70f58352840e0f41cfba0d",
};
